var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.72,
    height: 44,
    viewBox: "0 0 48.72 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #a1cd45;\n      }\n\n      .cls-2 {\n        fill: #a0cd45;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "newlogo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.09,35.85H5.43v2.91H7.05c1,0,1.7-.5,1.7-1.44A1.49,1.49,0,0,0,7.09,35.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48.12,18.91,25.61.48a1.87,1.87,0,0,0-2.5,0L.61,18.91A1.88,1.88,0,0,0,0,20.29V42.14A1.86,1.86,0,0,0,1.86,44h45a1.85,1.85,0,0,0,1.85-1.86V20.29A1.91,1.91,0,0,0,48.12,18.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.37,32.91a2.85,2.85,0,0,0-2.85,3,2.88,2.88,0,0,0,2.88,3,2.84,2.84,0,0,0,2.85-3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.36,35.85v2.91H26c1,0,1.69-.5,1.69-1.44A1.48,1.48,0,0,0,26,35.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "33.72 29.71 33.71 22.76 29.57 23.77 31.65 29.71 33.72 29.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "36.99 29.7 39.06 23.76 34.91 22.76 34.92 29.7 36.99 29.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M16.4,31a4.92,4.92,0,1,0,0,9.83,4.92,4.92,0,1,0,0-9.83Zm0,7.9a2.88,2.88,0,0,1-2.88-3,2.85,2.85,0,0,1,2.85-3,2.89,2.89,0,0,1,2.88,3A2.84,2.84,0,0,1,16.4,38.88Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "32.74 36.79 37.22 36.79 37.22 34.93 32.74 34.93 32.74 33 37.83 33 37.83 31.14 30.66 31.14 30.66 40.65 37.9 40.65 37.9 38.79 32.74 38.79 32.74 36.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M42.74,31.14H38.85v9.51h2.09V37.8h1.59c2.13,0,3.84-1.14,3.84-3.34C46.37,32.49,45,31.14,42.74,31.14Zm-.14,4.8H40.94V33h1.62c1,0,1.7.5,1.7,1.44A1.48,1.48,0,0,1,42.6,35.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M7,34H5.43v-.77H9.59V31.14H3.34v9.51H7.23c2.26,0,3.63-1.35,3.63-3.32C10.86,35.14,9.15,34,7,34Zm0,4.76H5.43V35.85H7.09a1.49,1.49,0,0,1,1.66,1.47C8.75,38.26,8.09,38.76,7.05,38.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M26,34H24.36v-.77h4.16V31.14H22.27v9.51h3.88c2.27,0,3.64-1.35,3.64-3.32C29.79,35.14,28.08,34,26,34Zm0,4.76H24.36V35.85H26a1.48,1.48,0,0,1,1.65,1.47C27.67,38.26,27,38.76,26,38.76Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8ce149fc141634f7482eb0774717d22e.svg";
export { ForwardRef as ReactComponent };